import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrdersComponent } from './orders.component';
import { OrdersRoutingModule } from './orders-routing.module';
import { RouterModule } from '@angular/router';
import { NgZorroAntdModule, NzButtonModule, NzDividerModule } from '../utilities/ng-zorro-antd.module';
import { AllOrdersComponent } from './all-orders/all-orders.component';
import { NewOrdersComponent } from './new-orders/new-orders.component';
import { OrderLogsComponent } from './order-logs/order-logs.component';
import { MomentModule } from 'ngx-moment';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ViewDetailsModule } from '../view-details/view-details.module';
import { OrdersDrawerComponent } from './all-orders/orders-drawer/orders-drawer.component';
import { EditOrdersComponent } from './all-orders/edit-orders/edit-orders.component';
import { ReceiptOrderDetailsComponent } from './all-orders/receipt-order-details/receipt-order-details.component';
import { GenerateOrderReceiptComponent } from './all-orders/generate-order-receipt/generate-order-receipt.component';
import { ProductsModule } from '../products/products.module';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { NgxPrintModule } from 'ngx-print';
import { OrderLogDrawerComponent } from './order-logs/order-log-drawer/order-log-drawer.component';
 

@NgModule({
    imports: [
        NgZorroAntdModule,
        RouterModule,
        CommonModule,
        OrdersRoutingModule,
        MomentModule,
        FormsModule,
        ReactiveFormsModule,
        ViewDetailsModule,
        ProductsModule,
        NgxQRCodeModule,
        NgxPrintModule,
        NzButtonModule,
        NzDividerModule
    ],
    declarations: [OrdersComponent, AllOrdersComponent, NewOrdersComponent, OrderLogsComponent, OrdersDrawerComponent, EditOrdersComponent, ReceiptOrderDetailsComponent, GenerateOrderReceiptComponent, OrderLogDrawerComponent],
    exports: [OrdersComponent, OrdersDrawerComponent, EditOrdersComponent, ReceiptOrderDetailsComponent, GenerateOrderReceiptComponent]
})
export class OrdersModule { }
